export const innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
  <path fill="currentcolor" d="M3.903 3.002a.9.9 0 0 1 .9.9v15.296h15.295l.092.005a.901.901 0 0 1 0 1.79l-.092.005H3.903a.901.901 0 0 1-.9-.9V3.903a.9.9 0 0 1 .9-.9Zm15.724 4.572a.75.75 0 0 1 1.239.845l-5.469 8a.752.752 0 0 1-1.123.133l-3.838-3.484-3.09 3.575a.75.75 0 0 1-1.136-.98l3.594-4.157.052-.055a.752.752 0 0 1 1.02-.01l3.768 3.42 4.983-7.287Z"/>
</svg>
`;
